class ModalManager {
  constructor(container) {
    this.modals = new Set();
    this.container = container;
    this.overflow = this.container.style.overflow;
  }

  register(modal) {
    if (this.modals.size === 0) {
      this.overflow = this.container.style.overflow;
      this.container.style.overflow = 'hidden';
    }

    this.modals.add(modal);

    return () => {
      this.unregister(modal);
    };
  }

  unregister(modal) {
    this.modals.delete(modal);

    if (this.modals.size === 0) {
      this.container.style.overflow = this.overflow;
    }
  }
}

export default ModalManager;
